<template>
     <section class="clp__header clp__header--products">            
            <div class=" clp__header-content">
                <div class="container">
                    <h1>{{ lang("Termekek_focim")}}</h1>
                    <div class="clp__category-menu-wrap" v-if="productsCategory">
                        <ul class="products__category-menu clp__category-menu">
                            <li v-for="category in productsCategory" :key="category.id + '_' + currentLangName()" @click="GTMProdCatClick(category.name)">
                                <a v-if="hasHttp(category.slug)" :href="category.slug" target="_blank">
                                    <img v-if="category.image" :src="src_url + '/' + category.image.path + '/' +category.image.file_name" :alt="category.name" :title="category.name"  class="img-fluid"  />
                                    <div>{{ category.name }}</div>
                                </a> 
                                <router-link v-else :to="{ name: 'ProductsCategoryList_' + currentLangName(), params: {product_category_slug: category.slug}}">                                       
                                    <img v-if="category.image" :src="src_url + '/' + category.image.path + '/' +category.image.file_name" :alt="category.name" :title="category.name"  class="img-fluid"  />
                                    <div>{{ category.name }}</div>
                                </router-link>                                
                            </li>
                        </ul>
                        <div class="prod-cat-carousel carousel-wrap" v-if="productsCategory.length > 0">
                            <carousel  :margin="16" :autoWidth="true" :dots="false"  :loop="false" :items="9" :responsive="{
                                768: {items: 5, margin:20},
                                992:{items:7, margin: 10}, 
                                1100: {items: 7, margin:22},                               
                                1200: {items: 8, margin:20},
                                1300: {items: 9, marign: 16}
                            }">
                                <div class="category-item" v-for="category in productsCategory" :key="category.id + '_' + currentLangName() + '_carousel'" @click="GTMProdCatClick(category.name)">
                                    <a v-if="hasHttp(category.slug)" :href="category.slug" target="_blank">
                                        <img v-if="category.image" :src="src_url + '/' + category.image.path + '/' +category.image.file_name" :alt="category.name" :title="category.name"  class="img-fluid"  />
                                        <div>{{ category.name }}</div>
                                    </a> 
                                    <router-link v-else :to="{ name: 'ProductsCategoryList_' + currentLangName(), params: {product_category_slug: category.slug}}">                                       
                                        <img v-if="category.image" :src="src_url + '/' + category.image.path + '/' +category.image.file_name" :alt="category.name" :title="category.name"  class="img-fluid"  />
                                        <div>{{ category.name }}</div>
                                    </router-link>                                
                                </div>
                            </carousel> 
                        </div>
                    </div>
                </div>
            </div>
        </section>  
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
    data(){
        return{
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },
    components:{
        carousel
    },
    computed:{       
        productsCategory(){            
            return this.$store.getters.getProducstCategory; 
        }              
    },
    methods:{
        hasHttp(link){
          return link.includes("http") ? true : false
        },
        GTMProdCatClick(category){          
            this.setDataLayer('product_category', category, '')                  
        } 
    }    
}
</script>